import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
// import Joyride from 'react-joyride';
import { useSelector } from 'react-redux';
import { generalAlertError } from '../../common/utils/alerts';
import { getAccidents, resetAccidentsList } from '../../features/accidents/accidentsActions';
import Pagination from '../../common/components/elements/Pagination';
// import { useTourContext } from '../../context/useTourContext';
import ErrorComponent from '../../common/components/ErrorComponent';
import { accident_statuses } from '../../common/constants';
// import { joyrideOptions } from '../../common/utils/joyrideUtils';
// import { handleCallbackAccidents } from '../../common/utils/joyrideCallbacks';
// import { accidentsSteps } from '../../common/utils/joyrideSteps';
import {
  AccidentsPageStyles,
  PageHeader,
  HeaderActions,
  AccidentCard,
  StatusBadge,
  ActionButton,
  FilterCard,
  SearchButton,
  EmptyState,
  LoadingState,
  AccidentsList,
  InfoChip,
  PostSaleButton,
} from './AccidentsPage.styles';

function AccidentsPage() {
  const navigate = useNavigate();
  const state = useSelector((store) => store.accidents.accidents_list);

  const {
    loading, accidents, page_number, total_pages, error,
  } = state;
  // const [steps, setSteps] = useState([]);

  const [search, setSearch] = useState({
    search: '',
    plate: '',
    date_from: '',
    date_to: '',
  });

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('accidents') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('accidents')]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('accidents');
  //   setState({ run: true, tourActive: true });
  // };

  // useEffect(() => {
  //   accidentsSteps(accidents, setSteps);
  // }, [accidents]);

  useEffect(() => {
    (async () => {
      getAccidents(1, search);
    })();

    return () => {
      resetAccidentsList();
    };
  }, []);

  const handleChange = ({ target: { value, name } }) => {
    setSearch({ ...search, [name]: value });
  };

  const searchHandler = async (e) => {
    e.preventDefault();

    if (search.date_from !== '' && search.date_to === '') {
      generalAlertError('Devi selezionare anche data al');
      return;
    }

    if (search.date_from === '' && search.date_to !== '') {
      generalAlertError('Devi selezionare anche data da');
      return;
    }

    const trimmedSearch = {
      ...search,
      search: search.search.trim(),
      plate: search.plate.trim(),
    };

    getAccidents(1, trimmedSearch);
  };

  return error === null ? (
    <AccidentsPageStyles>
      {/* <Joyride
        steps={steps}
        continuous
        showBeacon={showBeacon}
        locale={{
          back: 'Indietro',
          close: 'Chiudi',
          last: 'Fine',
          next: 'Prossima',
          open: 'Apri il modale',
          restart: 'Riavvia il tour ',
          skip: 'Salta',
        }}
        styles={{
          options: joyrideOptions,

          buttonNext: {
            backgroundColor: '#00a651',
            outline: 'none',
          },
          buttonBack: {
            color: '#00a651',
            outline: 'none',
          },
          beaconInner: {
            backgroundColor: '#00a651',
          },
          beaconOuter: {
            borderColor: '#00a651',
            backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
          },
          buttonSkip: {
            outline: 'none',
          },
          buttonClose: {
            outline: 'none',
          },
        }}
        run={run}
        callback={(data) => handleCallbackAccidents(data, steps, setState)}
        showSkipButton
        showProgress
      /> */}
      <div className="container-fluid">
        <PageHeader>
          <h2>🚨 Sinistri</h2>
          <HeaderActions>
            <PostSaleButton onClick={() => navigate('/after-sale/select')}>
              Vai a Post Vendita
            </PostSaleButton>
            {/* {localStorage.getItem('accidents') === 'done' && (
              <PostSaleButton onClick={() => fireNewQuoteTour()}>
                Tutorial
              </PostSaleButton>
            )} */}
          </HeaderActions>
        </PageHeader>

        <div className="row">
          {/* Main Content */}
          <div className="col-lg-7 col-xl-8 col-xxl-9 order-2 order-lg-1">
            {loading ? (
              <LoadingState className="accidents-one">
                <div className="spinner-border" role="status" />
                <span>Caricamento sinistri in corso...</span>
              </LoadingState>
            ) : (
              <>
                <AccidentsList className="accidents-one">
                  {accidents.length > 0 ? (
                    accidents.map((accident) => (
                      <AccidentCard
                        key={accident.id}
                        className="accidents-two"
                      >
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start gap-2">
                          <div className="accident-content">
                            {accident.quotation.active_customer && (
                              <div className="customer-name">
                                👤
                                {' '}
                                {accident.quotation.active_customer.gender === 'G'
                                  ? accident.quotation.active_customer.business_name
                                  : `${accident.quotation.active_customer.name} ${accident.quotation.active_customer.surname}`}
                              </div>
                            )}

                            <div className="accident-details">
                              <div className="detail-row">
                                <StatusBadge>
                                  {accident_statuses.find((status) => status.id == accident.status_id)?.name}
                                </StatusBadge>
                              </div>

                              <div className="info-chips-row">
                                {accident.quotation.insurance_request.product && (
                                  <InfoChip $highlight>
                                    📦
                                    {' '}
                                    {accident.quotation.insurance_request.product.name}
                                    {accident.quotation.insurance_request.product_id == 5
                                      ? ` (${accident.quotation.insurance_request.infortuni && accident.quotation.insurance_request.infortuni.company})`
                                      : ''}
                                  </InfoChip>
                                )}

                                {(accident.quotation.insurance_request.vehicle_plate || accident.quotation.insurance_request.moto_plate) && (
                                  <InfoChip $highlight>
                                    🚗
                                    {' '}
                                    {accident.quotation.insurance_request.vehicle_plate || accident.quotation.insurance_request.moto_plate}
                                  </InfoChip>
                                )}

                                {accident.quotation.insurance_request.professional && (
                                  <InfoChip>
                                    💼
                                    {' '}
                                    {accident.quotation.insurance_request.professional.profession_desc}
                                  </InfoChip>
                                )}

                                {accident.quotation.insurance_request.infortuni && (
                                  <InfoChip>
                                    🏥
                                    {' '}
                                    {accident.quotation.insurance_request.infortuni.pack_type}
                                    {' '}
                                    -
                                    {' '}
                                    {accident.quotation.insurance_request.infortuni.name}
                                  </InfoChip>
                                )}
                              </div>

                              <div className="created-date">
                                🕐 Creato il
                                {' '}
                                {new Date(accident.created_at).toLocaleDateString('it-IT', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                })}
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center">
                            {accident.status_id === 5 ? (
                              <Link to={`/accidents/${accident.id}`}>
                                <ActionButton>
                                  📋 Vai al sinistro
                                </ActionButton>
                              </Link>
                            ) : (
                              <Link to={`/after-sale/purchase/accident/${accident.id}`}>
                                <ActionButton>
                                  📋 Vai al sinistro
                                </ActionButton>
                              </Link>
                            )}
                          </div>
                        </div>
                      </AccidentCard>
                    ))
                  ) : (
                    <EmptyState className="accidents-no-result">
                      <div className="empty-icon">📭</div>
                      <h5>Nessun sinistro trovato!</h5>
                      <p>Prova a modificare i filtri di ricerca</p>
                    </EmptyState>
                  )}
                </AccidentsList>

                <div className="mt-4">
                  <Pagination
                    total_pages={total_pages}
                    current_page={page_number}
                    onClick={getAccidents}
                    search={search}
                  />
                </div>
              </>
            )}
          </div>

          {/* Filters Sidebar */}
          <div className="col-lg-5 col-xl-4 col-xxl-3 order-1 order-lg-2 mb-4 mb-lg-0">
            <FilterCard className="accidents-three">
              <h5>🔍 Filtri di Ricerca</h5>
              <form
                onSubmit={searchHandler}
                className="d-flex flex-column gap-3"
              >
                <div>
                  <label htmlFor="search">Ricerca cliente</label>
                  <input
                    type="text"
                    name="search"
                    id="search"
                    className="form-control"
                    value={search.search}
                    onChange={handleChange}
                    placeholder="Nome, cognome..."
                  />
                </div>

                <div>
                  <label htmlFor="plate">Ricerca targa</label>
                  <input
                    type="text"
                    name="plate"
                    id="plate"
                    className="form-control"
                    value={search.plate}
                    onChange={handleChange}
                    placeholder="Targa..."
                  />
                </div>

                <div>
                  <label htmlFor="date_from">Data creazione da</label>
                  <input
                    type="date"
                    name="date_from"
                    id="date_from"
                    onChange={handleChange}
                    value={search.date_from}
                    className="form-control"
                    lang="it-IT"
                  />
                </div>

                <div>
                  <label htmlFor="date_to">Data creazione al</label>
                  <input
                    type="date"
                    name="date_to"
                    id="date_to"
                    className="form-control"
                    onChange={handleChange}
                    value={search.date_to}
                    min={search.date_from}
                    lang="it-IT"
                  />
                </div>

                <SearchButton type="submit">
                  Cerca
                </SearchButton>
              </form>
            </FilterCard>
          </div>
        </div>
      </div>
    </AccidentsPageStyles>
  ) : (
    <ErrorComponent error={error} />
  );
}

export default AccidentsPage;
